import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter, RouterModule } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '@pxl/environments/environment';
import { AppComponent } from './app.component';
import { CoreModule } from '@pxl/core/core.module';
import { provideHighlightOptions } from 'ngx-highlightjs';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, RouterModule, CoreModule],
  providers: [
    provideHighlightOptions({
      coreLibraryLoader: () => import('highlight.js/lib/core'),
      lineNumbersLoader: () => import('ngx-highlightjs/line-numbers'),
      languages: {
        xml: () => import('highlight.js/lib/languages/xml')
      },
      themePath: 'assets/styles/github.css'
    }),
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAnimations()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
